<template>
  <div>
    <div v-if="data.isLoading" class="ajax-loading-wrapper mt-10">
      <span class="ajax-loading"></span>
    </div>
    <div v-if="!data.isLoading">
      <GMapMap
        :zoom="zoom"
        :center="data.center"
        :options="data.options"
        style="width:100%;  height: 800px;"
      >
        <GMapCluster :zoomOnClick="true" :minimumClusterSize="6" >
          <div
            :key="index"
            v-for="(marker, index) in data.markers"
          >
            <GMapMarker
              :position="{lat: marker.lat, lng: marker.lng}"
              @click="openWindow(marker.id)"
              :icon="mapIcon()"
            ></GMapMarker>
            <GMapInfoWindow
              @closeclick="data.window_open_id=false"
              :opened="data.window_open_id === marker.id"
              :position="{lat: marker.lat, lng: marker.lng}"
            >
              <div class='map__marker'>
                <a :href="marker.link">
                  <div class='map__marker-info'>
                    <div class='map__marker-img'>
                      <img :src='marker.image' loading="lazy" :alt="marker.name"/>
                    </div>
                    <div class='map__marker-text'>
                      <div class='map__marker-name' :class="{ 'mb-1': type === 'hfs'}">{{ marker.name }}</div>
                      <div
                        class='map__marker-address'
                        :class="{ 'color-pickled opacity-8': type === 'hfs'}"
                      >{{ marker.address }}</div>
                    </div>
                  </div>
                  <div class='map__hfs-data' v-if="type === 'hfs'">
                    <div class="map__hfs-data-bbc" v-if="marker.bedrooms">
                      <i class="icon icon--bed"></i> {{ marker.bedrooms }}
                    </div>
                    <div class="map__hfs-data-bbc" v-if="marker.bathrooms">
                      <i class="icon icon--bath"></i> {{ marker.bathrooms }}
                    </div>
                    <div class="map__hfs-data-bbc" v-if="marker.car_parks">
                      <i class="icon icon--car"></i>  {{ marker.car_parks }}
                    </div>
                  </div>
                </a>
                <div class='map__marker-compare' v-if="type === 'careHome'">
                  <div class='map__compare checkbox-custom'>
                    <input
                      type='checkbox'
                      class='levelOfCare'
                      :id=addCompareInputId(marker.id)
                      name='compare[]'
                      :value=marker.id
                      :data-care-home-name="marker.name"
                      :data-operator-id="marker.operatorId"
                      :data-operator-name="marker.operatorName"
                      :data-subscription="marker.subscription"
                      :data-enquiry-region="marker.region"
                      :data-enquiry-district="marker.district"
                      :checked='isCompareChecked(marker.id)'
                      @change="addRemoveToCompareList(marker.id, marker.name, $event)"
                    >
                    <label class='form-check-label mb-0' :for=addCompareInputId(marker.id)>
                      <span v-if='!isCompareChecked(marker.id)'>Add to compare</span>
                      <span v-if='isCompareChecked(marker.id)'>Added to compare</span>
                    </label>
                  </div>
                </div>
              </div>
            </GMapInfoWindow>
          </div>
        </GMapCluster>
      </GMapMap>
    </div>
  </div>
</template>

<script setup>
import { defineProps, reactive, onMounted } from 'vue';
import axios from 'axios';
import {useRestHomeCompare} from '../../composables/useRestHomeCompare';

const {addRemoveToCompareList, isCompareChecked} = useRestHomeCompare()

const props = defineProps({
  mapCentre: {
    type: Object,
    default: () => [],
  },
  zoom: {
    type: Number,
    default: 8,
  },
  region: {
    type: String,
    default: '',
  },
  district: {
    type: String,
    default: '',
  },
  suburb: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'careHome',
  },
});

// Data properties
const data = reactive({
  options: {
    mapTypeControl: false,
    streetViewControl: false,
    zoomControlOptions: {
      position: 3 // top right
    },
  },
  center: props.mapCentre,
  locationMarkers: [],
  window_open_id: false,
  markers: [],
  isLoading: true,
});

// Methods
const addCompareInputId = (id) => {
  return `compare_${id}`;
};

const locateGeoLocation = () => {
  navigator.geolocation.getCurrentPosition(res => {
    data.center = {
      lat: res.coords.latitude,
      lng: res.coords.longitude
    };
  });
};

const openWindow = (id) => {
  data.window_open_id = id;
};

const mapIcon = () => {
  let icon = '/icons/map-icon.png';
  if (props.type === 'hfs') {
    icon = '/icons/map-icon-orange.png';
  }
  return icon;
};

onMounted(() => {
  let url = `/ajax/care-home-list-map?region=${props.region}`;
  if (props.type === 'village') {
    url = `/ajax/village-list-map?region=${props.region}`;
  }
  if (props.type === 'hfs') {
    url = `/ajax/hfs-list-map?region=${props.region}`;
  }
  if (props.district) {
    url += `&district=${props.district}`
  }
  if (props.suburb) {
    url += `&suburb=${props.suburb}`
  }
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const size = urlParams.get('size');
  const levelCare = urlParams.get('level-care');
  const typeRoom = urlParams.get('type-of-rooms');
  const homeTypes = urlParams.get('home-types');
  if (size) {
    url += `&size=${size}`
  }
  if (levelCare) {
    url += `&level-care=${levelCare}`
  }
  if (typeRoom) {
    url += `&type-of-rooms=${typeRoom}`
  }
  if (homeTypes) {
    url += `&home-types=${homeTypes}`
  }
  axios.get(url).then((response) => {
    data.isLoading = false;
    data.markers = response.data.markers;
  });
});
</script>
